import React from 'react';
import { Calendar, Shield, Activity, Smile } from 'lucide-react';
export function WeeklyPlanSection() {
  return <section className="py-16 md:py-24 bg-white" data-id="element-175">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-176">
        <div className="text-center mb-16" data-id="element-177">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-178">
            ¿Qué vas a lograr en 21 días?
          </h2>
          <p className="text-xl text-slate-600" data-id="element-179">
            Un plan paso a paso diseñado para tu seguridad y progreso constante.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-180">
          {/* Week 1 */}
          <div className="bg-stone-50 rounded-2xl p-8 border-2 border-stone-100 hover:border-emerald-200 transition-colors" data-id="element-181">
            <div className="bg-emerald-100 w-14 h-14 rounded-full flex items-center justify-center mb-6" data-id="element-182">
              <Activity className="h-7 w-7 text-emerald-600" data-id="element-183" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-184">Semana 1</h3>
            <h4 className="text-lg font-semibold text-emerald-700 mb-4" data-id="element-185">
              Movilidad y Alivio
            </h4>
            <p className="text-slate-600" data-id="element-186">
              Reduce la rigidez matutina y "aceita" tus articulaciones con
              movimientos suaves que despiertan tus rodillas sin dolor.
            </p>
          </div>

          {/* Week 2 */}
          <div className="bg-stone-50 rounded-2xl p-8 border-2 border-stone-100 hover:border-emerald-200 transition-colors relative overflow-hidden" data-id="element-187">
            <div className="absolute top-0 right-0 bg-amber-400 text-xs font-bold px-3 py-1 rounded-bl-lg text-slate-900" data-id="element-188">
              CLAVE
            </div>
            <div className="bg-emerald-100 w-14 h-14 rounded-full flex items-center justify-center mb-6" data-id="element-189">
              <Shield className="h-7 w-7 text-emerald-600" data-id="element-190" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-191">Semana 2</h3>
            <h4 className="text-lg font-semibold text-emerald-700 mb-4" data-id="element-192">
              Fortaleza Invisible
            </h4>
            <p className="text-slate-600" data-id="element-193">
              Crea un "escudo de músculo" alrededor de tu rodilla que absorba el
              impacto al caminar. Fortalece sin levantar pesas.
            </p>
          </div>

          {/* Week 3 */}
          <div className="bg-stone-50 rounded-2xl p-8 border-2 border-stone-100 hover:border-emerald-200 transition-colors" data-id="element-194">
            <div className="bg-emerald-100 w-14 h-14 rounded-full flex items-center justify-center mb-6" data-id="element-195">
              <Smile className="h-7 w-7 text-emerald-600" data-id="element-196" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-197">Semana 3</h3>
            <h4 className="text-lg font-semibold text-emerald-700 mb-4" data-id="element-198">
              Confianza Total
            </h4>
            <p className="text-slate-600" data-id="element-199">
              Recupera el equilibrio y la confianza para subir escaleras,
              caminar en el parque o jugar con tus nietos sin miedo.
            </p>
          </div>
        </div>
      </div>
    </section>;
}